/*
 * @Copyright: @ Silk Software Corp. All Rights Reserved Based on MIT-LICENSE
 */
import { gql } from '@apollo/client'

export const B3_GET_ALL_ADDRESSES = gql`
  query getAllAddresses(
    $companyId: Int!
    $first: Int
    $offset: Int
    $search: String
    $firstName: String
    $lastName: String
    $address: String
    $country: String
    $state: String
    $city: String
    $label: String
    $isShipping: Decimal
    $isBilling: Decimal
  ) {
    addresses(
      companyId: $companyId
      first: $first
      offset: $offset
      search: $search
      firstName: $firstName
      lastName: $lastName
      address: $address
      country: $country
      state: $state
      city: $city
      label: $label
      isShipping: $isShipping
      isBilling: $isBilling
    ) {
      edges {
        node {
          entityId: id
          firstName
          lastName
          isShipping
          isBilling
          addressLine1
          addressLine2
          city
          state
          country
          countryCode
          zipCode
          phoneNumber
          label
          extraFields {
            fieldName
            fieldValue
          }
          isDefaultShipping
          isDefaultBilling
        }
      }
      pages: pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      total: totalCount
    }
  }
`
